<i18n>
{
  "fr": {
    "projectname-label": "Nom du projet",
    "required-field": "Ce champs est requis"
  },
  "de": {
    "projectname-label": "Name des projket",
    "required-field": "Dieses Feld wird benötigt"
  }
}
</i18n>

<template>
  <div v-if="show">

    <md-autocomplete
      v-model="project.name"
      :md-options="filtredProjects()"
      :md-open-on-focus="false"
      v-on:md-selected="onProjectSelected"
      v-on:md-changed="onProjectChanged"
      :class="getValidationClass('name')"
      required
    >
      <template slot="md-autocomplete-item" slot-scope="{ item, term }">
        <md-highlight-text :md-term="term">{{ item }}</md-highlight-text>
      </template>
      <label>{{ $t('projectname-label') }}</label>
      <span class="md-error" v-if="!$v.project.name.required">{{ $t('required-field') }}</span>
    </md-autocomplete>

  </div>
</template>

<script>

import _ from 'lodash'
import { validationMixin } from 'vuelidate'
import {
  required
} from 'vuelidate/lib/validators'

import Project from '@/models/default/Project'

export default {
  name: 'ProjectForm',
  mixins: [validationMixin],
  validations: {
    project: {
      name: {
        required
      }
    }
  },
  props: {
    project: {
      type: Object,
      default: () => { return new Project() }
    },
    projects: {
      type: Array,
      default: () => { return [] }
    },
    show: {
      type: Boolean,
      default: () => { return true }
    }
  },
  event: 'change',
  data () {
    return {

    }
  },
  methods: {
    getValidationClass (fieldName) {
      const field = this.$v.project[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    filtredProjects () {
      return new Promise((resolve, reject) => {
        let searchTerm = this.project.name
        if (!searchTerm) {
          resolve(this.projects.map(c => c.name))
        } else {
          resolve(this.projects.filter((project) => {
            return project.name.toLowerCase().includes(searchTerm.toLowerCase())
          }).map(c => c.name))
        }
      })
    },
    onProjectSelected (name) {
      let selectedProject = this.projects.find((project) => {
        return project.name === name
      })

      this.$emit('change', _.clone(selectedProject))
    },
    onProjectChanged (searchTerm) {
      if (searchTerm === '') {
        this.$emit('change', new Project())
      }
    }
  }
}
</script>

<style lang="scss">
.md-layout-item {
  padding: 10px;
}
</style>
